import { render, staticRenderFns } from "./ProductFilterSlider.vue?vue&type=template&id=6ae7f624&scoped=true&"
import script from "./ProductFilterSlider.vue?vue&type=script&lang=js&"
export * from "./ProductFilterSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProductFilterSlider.vue?vue&type=style&index=0&id=6ae7f624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae7f624",
  null
  
)

export default component.exports